import React, { memo, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SelectInput } from "../../../components/common/UI/Inputs/InputControls";
import { useNavigate } from "react-router-dom";
import WarningModal from "../../WarningModal";
import { authActions } from "../../../_store";
import TranslateFile from "../../../config/TranslateFile";
import { getStoredValue, removeStoredValue, setStoredValue } from "../../../_helpers/storagehelper";


function DropdownNotification() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentLang = TranslateFile();


    // const SESSION_TIMEOUT = parseInt(process.env.REACT_APP_SESSION_TIMEOUT, 10) || 300;
    // const SESSION_WARNING = parseInt(process.env.REACT_APP_SESSION_WARNING, 10) || 10;

    const SESSION_TIMEOUT = 4800;
    const SESSION_WARNING = 10;



    const [timeLeft, setTimeLeft] = useState(SESSION_TIMEOUT);
    const [isShowAlert, setIsShowAlert] = useState(false);


    const logout = () => {
        dispatch(authActions.logout());
        removeStoredValue("sessionExpirationTime");
        navigate("/public/Login");
    };

    const resetTimer = () => {
        const newExpirationTime = Date.now() + SESSION_TIMEOUT * 1000;
        setStoredValue("sessionExpirationTime", newExpirationTime.toString());
        setTimeLeft(SESSION_TIMEOUT);
        setIsShowAlert(false);
    };

    useEffect(() => {
        const expirationTime = getStoredValue("sessionExpirationTime");
        if (!expirationTime) {
            resetTimer();
        }

        const interval = setInterval(() => {
            const expirationTime = parseInt(getStoredValue("sessionExpirationTime"), 10);
            const remainingTime = Math.floor((expirationTime - Date.now()) / 1000);

            if (remainingTime <= 0) {
                logout();
                clearInterval(interval);
            } else {
                setTimeLeft(remainingTime);

                if (remainingTime <= SESSION_WARNING && !isShowAlert) {
                    setIsShowAlert(true);
                }
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [isShowAlert]);

    useEffect(() => {
        const handleUserActivity = () => resetTimer();

        window.addEventListener("mousemove", handleUserActivity);
        window.addEventListener("keydown", handleUserActivity);
        window.addEventListener("click", handleUserActivity);
        document.addEventListener("visibilitychange", handleUserActivity);

        return () => {
            window.removeEventListener("mousemove", handleUserActivity);
            window.removeEventListener("keydown", handleUserActivity);
            window.removeEventListener("click", handleUserActivity);
            document.removeEventListener("visibilitychange", handleUserActivity);
        };
    }, []);
    // const [language, setLanguage] = useState("en"); // Default language

    // Function to change the language
    const changeLanguage = (lang) => {
        setLanguage(lang);
    };
    const handleToggle = (e) => {
        const isChecked = e.target.checked; // This will be true if the toggle is ON, false otherwise
        setLanguage(isChecked ? 'en' : 'es');
        setStoredValue("lang", isChecked ? 'en' : 'es'); window.location.reload();
    };



    const [language, setLanguage] = useState(getStoredValue("lang") || "en"); // Default language is English



    return (


        <>
            <div className="header-right">
                <div className="header-right-content">
                    <span className="header-username">
                        <div></div>
                    </span>
                </div>
            </div>
            <div className="mt--10 d-flex gap-2 justify-content-center align-items-center">
                <p className="mb-0 font-size-15 line-height-normal">{currentLang?.Translate}</p>
                <div className="language-toggle">
                    <label className="toggle-switch">
                        <input
                            type="checkbox"
                            checked={language === "en"}
                            onChange={(e) => { handleToggle(e) }}
                        />
                        <span className="slider" style={{ justifyContent: language === "en" ? 'flex-start' : 'flex-end' }}>
                            {(getStoredValue("lang") || "en")?.toUpperCase()}
                        </span>
                    </label>
                </div>

            </div>

            {/* {isShowAlert && (
                <WarningModal
                    onLogout={logout}
                    onExtendSession={resetTimer}
                    timeLeft={timeLeft}
                />
            )} */}
        </>
    );
}

export default memo(DropdownNotification);
